<template>
  <el-dialog
    width="45%"
    class="dialog"
    :title="type == 'add' ? '新增门店' : '编辑门店'"
    :visible.sync="dialogFormVisible"
    :close-on-click-modal="false"
  >
    <el-form
      ref="ruleForm"
      label-position="right"
      :rules="rules"
      :model="formData"
      label-width="120px"
    >
      <!-- 编辑态：门店编码（只读） -->
      <el-form-item v-if="type == 'edit'" label="门店编码" prop="storeCode">
        <el-input v-model="formData.storeCode" disabled></el-input>
      </el-form-item>
      <el-form-item label="门店名称" prop="storeName">
        <el-input
          :disabled="type == 'edit'"
          v-model="formData.storeName"
          placeholder="请输入门店名称（最多50个中文字）"
          clearable
          maxlength="50"
        ></el-input>
      </el-form-item>
      <!-- 省市联动 -->
      <el-form-item label="所在省份" prop="provinceCode">
        <el-select
          v-model="formData.provinceCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          @change="provinceChange"
        >
          <el-option
            v-for="item in provinceList"
            :key="item.provinceCode"
            :label="item.provinceName"
            :value="item.provinceCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="所在城市" prop="cityCode">
        <el-select
          v-model="formData.cityCode"
          placeholder="请选择"
          clearable
          style="width: 100%"
          :disabled="!formData.provinceCode"
          @change="cityChange"
        >
          <el-option
            v-for="item in cityList"
            :key="item.cityCode"
            :label="item.cityName"
            :value="item.cityCode"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="联系电话" prop="contactMobile">
        <el-input
          v-model="formData.contactMobile"
          placeholder="请输入11位手机号"
          clearable
          maxlength="11"
        ></el-input>
      </el-form-item>
      <el-form-item label="联系人" prop="contactName">
        <el-input
          v-model="formData.contactName"
          placeholder="请输入联系人姓名（最多5个中文字）"
          clearable
          maxlength="5"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取消</el-button>
      <el-button type="primary" :loading="btnLoading" @click="submitBtnFun">确认</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  saveStore,
  updateStore,
  findAllProvince,
  findAllCity
} from "@/api/thirdPartyTradeIn";

export default {
  name: "storeDialog",
  data() {
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error("手机号必填"));
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error("手机号格式不正确"));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      type: "add", // add 新增模式 edit 编辑模式
      originalId: undefined, // 编辑时的门店id
      provinceList: [],
      cityList: [],
      cityRequestSeq: 0, // 城市列表请求序号，用于丢弃过期响应
      formData: {
        storeCode: undefined,
        storeName: undefined,
        provinceCode: undefined,
        provinceName: undefined,
        cityCode: undefined,
        cityName: undefined,
        contactMobile: undefined,
        contactName: undefined
      },
      rules: {
        storeName: [
          { required: true, message: "门店名称必填", trigger: "blur" }
        ],
        provinceCode: [
          { required: true, message: "所在省份必填", trigger: "change" }
        ],
        cityCode: [
          { required: true, message: "所在城市必填", trigger: "change" }
        ],
        contactMobile: [
          { required: true, validator: validatePhone, trigger: "blur" }
        ],
        contactName: [
          { required: true, message: "联系人姓名必填", trigger: "blur" }
        ]
      },
      btnLoading: false
    };
  },
  watch: {
    dialogFormVisible(val) {
      if (!val) {
        this.$refs.ruleForm && this.$refs.ruleForm.resetFields();
      }
    }
  },
  methods: {
    // 关闭弹框（取消时二次确认）
    closeDialog() {
      this.$confirm("是否确认退出", "提示", {
        confirmButtonText: "是",
        cancelButtonText: "否",
        type: "warning"
      })
        .then(() => {
          this.dialogFormVisible = false;
        })
        .catch(() => {});
    },
    // 打开弹框
    async openDialog(type, rowData) {
      this.type = type;
      this.resetFormData();
      if (type == "edit" && rowData) {
        this.originalId = rowData.id;
        this.formData.storeCode = rowData.storeCode || rowData.id;
        this.formData.storeName = rowData.storeName;
        this.formData.provinceCode = rowData.provinceCode;
        this.formData.provinceName = rowData.provinceName;
        this.formData.cityCode = rowData.cityCode;
        this.formData.cityName = rowData.cityName;
        this.formData.contactMobile = rowData.contactMobile;
        this.formData.contactName = rowData.contactName;
        // 回填后加载城市列表
        if (rowData.provinceCode) {
          this.getCityList(rowData.provinceCode, true);
        }
      }
      this.dialogFormVisible = true;
    },
    // 获取省份列表
    async getProvinceList() {
      let { data, statusCode } = await findAllProvince();
      if (statusCode == 200) {
        this.provinceList = data || [];
      }
    },
    // 获取城市列表（是否保留已选城市值）
    async getCityList(provinceCode, keepCity) {
      const seq = ++this.cityRequestSeq;
      this.cityList = [];
      if (!keepCity) {
        this.formData.cityCode = undefined;
        this.formData.cityName = undefined;
      }
      if (!provinceCode) return;
      let { data, statusCode } = await findAllCity(provinceCode);
      // 仅采用最新一次请求的结果，避免上一次打开的旧城市数据覆盖本次
      if (seq !== this.cityRequestSeq) return;
      if (statusCode == 200) {
        this.cityList = data || [];
      }
    },
    // 省份改变
    provinceChange(val) {
      const current = (this.provinceList || []).find(
        item => item.provinceCode === val
      );
      this.formData.provinceName = current ? current.provinceName : undefined;
      this.getCityList(val, false);
    },
    // 城市选中时记录名称
    cityChange() {
      const current = (this.cityList || []).find(
        item => item.cityCode === this.formData.cityCode
      );
      this.formData.cityName = current ? current.cityName : undefined;
    },
    // 表单重置
    resetFormData() {
      // 使上一次打开时仍在途的城市请求失效
      this.cityRequestSeq++;
      this.formData = {
        storeCode: undefined,
        storeName: undefined,
        provinceCode: undefined,
        provinceName: undefined,
        cityCode: undefined,
        cityName: undefined,
        contactMobile: undefined,
        contactName: undefined
      };
      this.cityList = [];
    },
    // 确认提交
    submitBtnFun() {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.btnLoading = true;
          this.saveFormDataReq();
        } else {
          return false;
        }
      });
    },
    // 新增 or 编辑
    async saveFormDataReq() {
      // 新增与编辑的省ID字段名不同：新增用 provinceCode，编辑用 provinceId
      let requestData = {
        storeName: this.formData.storeName,
        provinceName: this.formData.provinceName,
        cityName: this.formData.cityName,
        cityCode: this.formData.cityCode,
        contactName: this.formData.contactName,
        contactMobile: this.formData.contactMobile
      };
      if (this.type == "edit") {
        requestData.id = this.originalId;
        requestData.provinceCode = this.formData.provinceCode;
      } else {
        requestData.provinceCode = this.formData.provinceCode;
      }
      let { statusCode, message } =
        this.type == "edit"
          ? await updateStore(requestData)
          : await saveStore(requestData);
      if (statusCode == 200) {
        this.btnLoading = false;
        this.$message.success(this.type == "edit" ? "编辑成功" : "新增成功");
        this.$emit("opera-success");
        this.dialogFormVisible = false;
      } else {
        this.btnLoading = false;
        this.$message.error(message);
      }
    }
  },
  mounted() {
    this.getProvinceList();
  }
};
</script>
<style scoped lang="scss">
.dialog {
  padding: 0 20px;
  .el-dialog__body {
    padding-top: 10px;
  }
  .dialog-footer {
    padding: 20px;
    padding-top: 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/thirdPartyTradeIn/storeManagement/components/storeDialog.vue